import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7837e266"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "absolute inset-0 size-full" };
const _hoisted_2 = ["id", "viewBox"];
const _hoisted_3 = ["id", "d"];
const _hoisted_4 = ["transform"];
const _hoisted_5 = ["href"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tspan", null, " ", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("tspan", null, " ", -1));
const _hoisted_8 = { class: "Inner absolute inset-0" };
const _hoisted_9 = { class: "Spinner size-full" };
const _hoisted_10 = ["href"];
import { ref, getCurrentInstance, watch, computed } from "vue";
import { useElementSize } from "@vueuse/core";
const DEFAULT_DURATION = 20;
const TEXT_OFFSET = 2;
export default /*#__PURE__*/ _defineComponent({
    __name: 'UICircularText',
    props: {
        text: {},
        as: { default: "div" },
        spin: { type: Boolean, default: DEFAULT_DURATION }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "3f0a15fc": (duration.value)
        }));
        const props = __props;
        const root = ref(null);
        const path = ref(null);
        const textSpan = ref([]);
        const nbClones = ref(1);
        const setNbClones = (val) => (nbClones.value = Math.max(1, val));
        const { uid } = getCurrentInstance();
        const { width, height } = useElementSize(root);
        const size = computed(() => Math.min(width.value, height.value));
        const cx = computed(() => 0.5 * size.value);
        const cy = computed(() => 0.5 * size.value);
        const r = computed(() => 0.5 * size.value - TEXT_OFFSET);
        const duration = computed(() => `${typeof props.spin === "boolean" && props.spin ? DEFAULT_DURATION : Number(props.spin)}s`);
        function setClones() {
            // clone text inside to fill the whole circle
            const [firstTextSpan] = textSpan.value;
            const textLength = firstTextSpan.getComputedTextLength();
            const totalLength = path.value.getTotalLength();
            if (textLength > 0) {
                setNbClones(Math.floor(totalLength / textLength));
            }
        }
        watch([width, height], setClones, { flush: "post" });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), {
                ref_key: "root",
                ref: root,
                class: "UICircularText relative flex justify-center items-center rounded-full fill-current font-atlas font-regular text-12 tracking-widest"
            }, {
                default: _withCtx(() => [
                    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                        _createElementVNode("symbol", {
                            id: `UICircularTextSymbol-${_unref(uid)}`,
                            viewBox: `0 0 ${size.value} ${size.value}`
                        }, [
                            _createElementVNode("path", {
                                id: `UICircularTextPath-${_unref(uid)}`,
                                ref_key: "path",
                                ref: path,
                                fill: "none",
                                d: `M${cx.value},${cy.value}m${r.value},0a${r.value},${r.value} 0 1,1 ${r.value * -2},0a${r.value},${r.value} 0 1,1 ${r.value * 2},0`
                            }, null, 8, _hoisted_3),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nbClones.value, (n, i) => {
                                return (_openBlock(), _createElementBlock("text", {
                                    key: n,
                                    transform: `rotate(${360 / nbClones.value * i} ${cx.value} ${cy.value})`
                                }, [
                                    _createElementVNode("textPath", {
                                        href: `#UICircularTextPath-${_unref(uid)}`,
                                        startOffset: "50%",
                                        "text-anchor": "middle"
                                    }, [
                                        _createElementVNode("tspan", {
                                            ref_for: true,
                                            ref_key: "textSpan",
                                            ref: textSpan,
                                            dy: "0.75em"
                                        }, [
                                            _hoisted_6,
                                            _createElementVNode("tspan", null, _toDisplayString(_ctx.text), 1),
                                            _hoisted_7
                                        ], 512)
                                    ], 8, _hoisted_5)
                                ], 8, _hoisted_4));
                            }), 128))
                        ], 8, _hoisted_2)
                    ])),
                    _createElementVNode("span", _hoisted_8, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                            _createElementVNode("use", {
                                href: `#UICircularTextSymbol-${_unref(uid)}`
                            }, null, 8, _hoisted_10),
                            _renderSlot(_ctx.$slots, "svg", {
                                size: size.value,
                                cx: cx.value,
                                cy: cy.value
                            })
                        ]))
                    ]),
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 512));
        };
    }
});
